import { render, staticRenderFns } from "./HomePageTemplate.vue?vue&type=template&id=dcf522ce&scoped=true"
import script from "./HomePageTemplate.vue?vue&type=script&lang=js"
export * from "./HomePageTemplate.vue?vue&type=script&lang=js"
import style0 from "./HomePageTemplate.vue?vue&type=style&index=0&id=dcf522ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf522ce",
  null
  
)

export default component.exports